import React, {FC, Suspense} from 'react';
import {TranslationContext} from './src/context/translation';
import {WrapPageElementBrowserArgs} from 'gatsby';

const CookieConsent = React.lazy(() => import('./src/lib/cookieConsent'));

const CookieNotice: FC = () => {
  const [loadCookieScript, setLoadCookieScript] = React.useState(false);
  const GDPR = [
    'at', 'be', 'bg', 'cy',
    'cz', 'dk', 'de', 'ee',
    'es', 'fi', 'fr', 'gb',
    'gr', 'hu', 'hr', 'ie',
    'it', 'lv', 'lt', 'lu',
    'mt', 'nl', 'po', 'pt',
    'ro', 'se', 'si', 'sk'
  ];
  const CCPA = ['ca'];

  const countryCode = window?.cb_data?.geoIP?.countryCode; // eslint-disable-line camelcase
  const stateCode = window?.cb_data?.geoIP?.stateCode; // eslint-disable-line camelcase

  if (loadCookieScript === false)
    if (
      // GDPR
      (GDPR.includes(countryCode?.toLowerCase() || ''))
      // CCPA (US-only)
      || (countryCode?.toLowerCase() === 'us' && CCPA.includes(stateCode?.toLowerCase() || ''))
    ) {
      setLoadCookieScript(true);
    }

  return (
    <>
      {
        loadCookieScript &&
        <Suspense fallback={<></>}>
          <CookieConsent />
        </Suspense>
      }
    </>
  );
};

const wrapPageElement = ({element}: WrapPageElementBrowserArgs) => (
  <>
    <CookieNotice />
    <TranslationContext.Provider value={{}}>
      {element}
    </TranslationContext.Provider>
  </>
);

export default wrapPageElement;
